import TiptapTableCell from '@tiptap/extension-table-cell';

export const TableCell = TiptapTableCell.extend({
  addAttributes() {
    return {
      // extend the existing attributes …
      ...this.parent?.(),

      // and add a new one …
      backgroundColor: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-background-color'),
        renderHTML: ({ backgroundColor }) => {
          const attrs: { 'data-background-color': string | null; style?: string } = {
            'data-background-color': backgroundColor,
          };
          if (backgroundColor) {
            attrs.style = `background-color: ${backgroundColor}`;
          }
          return attrs;
        },
      },
    };
  },
});
